import { Link } from 'react-router-dom';
import LegalPage from './LegalPage';
import { SUPPORT_EMAIL } from '../utils/constants';

const Terms = () => {
  return (
    <LegalPage title="Terms of Service" updated="June 11, 2026">
      <p>
        These are the terms for buying and using SolidlyAI Agents, the desktop app sold by
        Solidly on this website (agents.solidly.ai). They're written to be read, not to scare
        you — if anything is unclear, email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>

      <h2>The purchase</h2>
      <ul>
        <li>
          SolidlyAI Agents is a one-time purchase. You pay once and own your license for life,
          including all future updates — no subscription required.
        </li>
        <li>Payment is processed by Stripe. Prices are shown in USD at checkout.</li>
      </ul>

      <h2>Your license</h2>
      <ul>
        <li>
          Your license is personal to you and can be activated on up to 3 devices. Need more?
          Email us.
        </li>
        <li>
          Don't resell, share, or redistribute your license key or the app itself. That's the
          whole list of restrictions.
        </li>
      </ul>

      <h2>Solidly Sync (optional add-on)</h2>
      <ul>
        <li>
          Solidly Sync is an optional $5/month subscription for encrypted backup and
          multi-device sync. You can cancel anytime; the app keeps working fully on your device
          without it.
        </li>
        <li>
          If you cancel Sync, new snapshot uploads stop. Your local data is unaffected — it
          lives on your machine.
        </li>
      </ul>

      <h2>Your providers, your keys</h2>
      <p>
        The app runs on your own Claude subscription and your own transcription provider key.
        You're responsible for those accounts, their costs, and complying with their terms.
        Solidly doesn't resell or mark up your providers, and isn't responsible for their
        availability or output.
      </p>

      <h2>Refunds</h2>
      <p>
        7-day money-back guarantee: if the app isn't for you, email{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> within 7 days of purchase and
        we'll refund you in full — no forms, no questions.
      </p>

      <h2>The honest disclaimer</h2>
      <p>
        The app is provided "as is." We work hard to keep it reliable, but we can't guarantee
        it will be uninterrupted or error-free, and AI output should always be reviewed before
        you rely on it. To the maximum extent permitted by law, Solidly's total liability for
        any claim related to the app is limited to the amount you paid for it.
      </p>

      <h2>Changes</h2>
      <p>
        If we update these terms, we'll update the date at the top of this page. Material
        changes won't take away anything you've already bought.
      </p>

      <p>
        See also: <Link to="/privacy">Privacy Policy</Link>. Questions go to{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
    </LegalPage>
  );
};

export default Terms;
